class crop_insurance {
    constructor() {
      const WEBDOCCROPINSDAILY1 = "WEBDOCCROPINSDAILY1";
      const WEBDOCCROPINSDAILY2 = "WEBDOCCROPINSDAILY2";
      const WEBDOCCROPINSDAILY3 = "WEBDOCCROPINSDAILY3";
      const WEBDOCCROPINSDAILY4 = "WEBDOCCROPINSDAILY4";
      this.items = [
        {
          serviceId: 1,
          pid: WEBDOCCROPINSDAILY1,
          name: "WebdocCropInsDaily1",
          serviceName:"Crop Insurance",
          badge: "Basic",
          coverage: "20,000",
          price:"3.5",
          bgColorClass: "bg-info",
          description: `<p><strong>Crop Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection in case of crop damage due to natural disaster.</p>
<ul>
<li><strong>Coverage: </strong>Up to Rs. 20,000</li>
<li><strong>Waiting Period:</strong> 30 days</li>
<li><strong>Subscription:</strong> Daily</li>
<li>Coverage is for 18-65 years old customers only </li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 30 days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Land ownership document to be provided, registered subscribers should have documents on their names</li>
</ul>`,
          type: "insurance",
        },
//         {
//           serviceId: 2,
//           pid: WEBDOCCROPINSDAILY2,
//           name: "WebdocCropInsDaily2",
//           serviceName:"Webdoc Crop Insurance",
//           badge: "Gold",
//           coverage: "40,000",
//           price:"7.0",
//           bgColorClass: "bg-warning",
//           description: `<p><strong>Crop Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection in case of crop damage due to natural disaster.</p>
// <ul>
// <li><strong>Coverage: </strong>Up to Rs. 40,000 on a pro-rata basis incase of natural disaster</li>
// <li><strong>Insurance Period:</strong> 30 days</li>
// <li><strong>Subscription:</strong> Daily</li>
// <li>Coverage is for 18-65 years old customers only </li>
// </ul>
// <p><strong>Claims:</strong></p>
// <ul>
// <li>Settled directly with the claimants within 3 working days of document submission</li>
// <li>End-to-end support and handholding to claimant</li>
// <li>Land ownership document to be provided, registered subscribers should have documents on their names</li>
// </ul>`,
//           type: "insurance",
//         },
        {
          serviceId: 3,
          pid: WEBDOCCROPINSDAILY3,
          name: "WebdocCropInsDaily3",
          serviceName:"Crop Insurance",
          badge: "Gold",
          coverage: "60,000",
          price:"11.0",
          bgColorClass: "bg-info",
          description: `<p><strong>Crop Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection in case of crop damage due to natural disaster.</p>
<ul>
<li><strong>Coverage: </strong>Up to Rs. 60,000</li>
<li><strong>Waiting Period:</strong> 30 days</li>
<li><strong>Subscription:</strong> Daily</li>
<li>Coverage is for 18-65 years old customers only </li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 30 days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Land ownership document to be provided, registered subscribers should have documents on their names</li>
</ul>`,
          type: "insurance",
        },

        {
          serviceId: 4,
          pid: WEBDOCCROPINSDAILY4,
          name: "WebdocCropInsDaily4",
          serviceName:"Crop Insurance",
          badge: "Platinum",
          coverage: "80,000",
          price:"14.5",
          bgColorClass: "bg-info",
          description: `<p><strong>Crop Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection in case of crop damage due to natural disaster.</p>
<ul>
<li><strong>Coverage: </strong>Up to Rs. 80,000</li>
<li><strong>Waiting Period:</strong> 30 days</li>
<li><strong>Subscription:</strong> Daily</li>
<li>Coverage is for 18-65 years old customers only </li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 30 days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Land ownership document to be provided, registered subscribers should have documents on their names</li>
</ul>`,
          type: "insurance",
        }
      ];
    }
  
    getAllItems() {
      return this.items;
    }
  }
  
  export default crop_insurance;
  